import React from 'react'
import Loading from '../components/Loading'
import { useParams, Link } from 'react-router-dom'
const url = 'https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i='

const SingleCocktail = () => {

  const { id } = useParams();
  const [loading, setLoading] = React.useState(false)
  const [cocktail, setCocktail] = React.useState(null)

  React.useEffect(() => {
    setLoading(true)
    async function getCocktail() {
      try {
        const response = await fetch(`${url}${id}`)
        const data = await response.json();
        //console.log(data);
        if (data.drinks) {
          const { strDrink: name, strDrinkThumb: image,
            strAlcholoic: info, strCategory: category,
            strGlass: glass, strInstructions: instruction, strIngredient1, strIngredient2,
            strIngredient3, strIngredient4, strIngredient5, } = data.drinks[0]
          const ingredient = [strIngredient1, strIngredient2, strIngredient3, strIngredient4, strIngredient5,]
          const newCocktail = { name, image, info, category, glass, instruction, ingredient }
          setCocktail(newCocktail);
        }

        else {
          setCocktail(null);
        }
        setLoading(false)
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    }
    getCocktail()
  }, [id])

  if (loading) {
    return <Loading></Loading>
  }
  if (!cocktail) {
    return <h2 className='section-title'> no drinks available</h2>
  }

  // console.log(cocktail);
  const { name, image, category, info, glass, instruction, ingredient } = cocktail;
  return (
    <section className='section cocktail-section'>
      <Link to='/' className='btn btn-primary'>back home</Link>
      <h2 className='section-title'>{name}</h2>
      <div className="drink">
        <img src={image} alt={name} />
        <div className="drink-info">
          <p>
            <span className='drink-data'>
              name: </span>{name}
          </p>
          <p>
            <span className='drink-data'>
              category: </span>{category}
          </p>
          <p>
            <span className='drink-data'>
              info: </span> {info}
          </p>
          <p>
            <span className='drink-data'>
              glass: </span> {glass}
          </p>
          <p>
            <span className='drink-data'>
              instruction: </span> {instruction}
          </p>

          <p>
            <span className='drink-data'>ingredient:</span> {ingredient.map((item, index) => {
              return item ? <span key={index}> {item},</span> : null
            })}
          </p>
        </div>
      </div>

    </section>
  )
}

export default SingleCocktail
